<script setup>
import TICKETMEIMAGE from '@/assets/img/ticketme.png'
const { $get } = useApi()
const route = useRoute()
const { formatDate } = useDate()

function getDateOfNearestDay(day, date = new Date()) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + ((7 + day - date.getDay()) % 7)
  )
}

function getNextDay(date) {
  const time = new Date(new Date(date))

  return new Date(new Date(time.setDate(time.getDate() + 1)).setMinutes(0)).toISOString()
}

const dayInfo = computed(() => {
  if (route.query?.day) {
    switch (route.query?.day) {
      case 'today':
        return 'сегодня'
      case 'tomorrow':
        return 'завтра'
      case 'weekend':
        return 'в выходные'
      default: {
        return `${formatDate(new Date(route.query?.day), 'D MMMM')}`
      }
    }
  } else {
    return ''
  }
})

const calDateQuery = () => {
  const now = new Date()
  if (route.query?.day) {
    switch (route.query.day) {
      case 'today': {
        return `scheduleInfo.saleOpening_lte=${new Date(
          new Date(now)
        ).toISOString()}&scheduleInfo.presentationDate=${formatDate(
          now,
          'YYYY-MM-DD'
        )}&scheduleInfo.saleEnding_gte=${new Date(new Date(now)).toISOString()}`
      }
      case 'tomorrow': {
        const date = new Date(new Date(now).setDate(new Date(now).getDate() + 1))
        return `scheduleInfo.saleOpening_lte=${new Date(
          new Date(now)
        ).toISOString()}&scheduleInfo.presentationDate=${formatDate(
          date,
          'YYYY-MM-DD'
        )}&scheduleInfo.saleEnding_gte=${new Date(new Date(now)).toISOString()}`
      }
      case 'weekend': {
        let dateOfNearestSaturday = getDateOfNearestDay(6)
        dateOfNearestSaturday = new Date(dateOfNearestSaturday)
        let dateOfNearestSanday = getDateOfNearestDay(7)
        dateOfNearestSanday = new Date(dateOfNearestSanday)
        return `scheduleInfo.saleOpening_lte=${new Date(
          new Date(now)
        ).toISOString()}&scheduleInfo.presentationDate_eq=${formatDate(
          dateOfNearestSaturday,
          'YYYY-MM-DD'
        )}&scheduleInfo.presentationDate_eq=${formatDate(
          dateOfNearestSanday,
          'YYYY-MM-DD'
        )}&scheduleInfo.saleEnding_gte=${new Date(new Date(now)).toISOString()}`
      }
      default: {
        return `scheduleInfo.saleOpening_lte=${new Date(
          new Date(now)
        ).toISOString()}&scheduleInfo.presentationDate_eq=${formatDate(
          new Date(route.query.day),
          'YYYY-MM-DD'
        )}&scheduleInfo.saleEnding_gte=${new Date(new Date(now)).toISOString()}`
      }
    }
  } else {
    return `scheduleInfo.saleOpening_lte=${new Date(
      new Date(now)
    ).toISOString()}&scheduleInfo.saleEnding_gte=${new Date(new Date(now)).toISOString()}`
  }
}

const isLoading = ref(false)
const isMounted = ref(false)

const events = ref([])
onMounted(async () => {
  isLoading.value = true
  const dateQuery = calDateQuery()
  events.value = await $get(`/api/v1/event/get-the-nearest-events-of-activities-available-for-online?${dateQuery}`)
  isLoading.value = false
  isMounted.value = true
})

const head = computed(() => {
  return {
    title: `TicketMe`,
    meta: [
      {
        hid: 'title',
        property: 'title',
        content: `TicketMe`
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: `TicketMe`
      },
      {
        hid: 'description',
        name: 'description',
        content: 'Покупайте билеты на мероприятия в Абхазии онлайн – TicketMe'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Покупайте билеты на мероприятия в Абхазии онлайн – TicketMe'
      },
      {
        hid: 'url',
        name: 'url',
        content: `https://ticketme.biz/activities/event-by-dates`
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: `https://ticketme.biz/activities/event-by-dates`
      },
      {
        hid: 'image',
        name: 'image',
        content: `${TICKETMEIMAGE}`
      },
      {
        name: 'og:image',
        property: 'og:image',
        content: `${TICKETMEIMAGE}`
      }
    ]
  }
})

useHead(head)
</script>

<template>
  <NuxtLayout name="main-shop-layout">
    <h1 class="container pt-4 lg:pt-0 px-4 xl:px-0 font-sf-pro text-xl lg:text-4xl font-semibold mb-4">
      Афиша событий {{ dayInfo }}
    </h1>
    <div class="pb-12">
      <t-list-events v-if="!isLoading && isMounted" :events="events" />
      <div v-else class="md:mt-19">
        <t-sceleton-events />
      </div>
    </div>
    <t-main-recommendations class="pb-5 lg:pb-12" />
    <t-main-watched class="pb-5 pt-5 md:pt-0 md:pb-0" />
  </NuxtLayout>
</template>
